import React from 'react';

import Button from '../../components/button';
import Anchor from '../../components/anchor';
import './main-a.css';

import imgComputerPerson from '../../static/images/p01_2x.png';

import handleChat from '../../utils/handle-chat';

const Ellipse = () => <div className="ellipse" />;

class MainA extends React.Component {
  render() {
    return (
      <div className="home-main">
        <div className="home-container">
          <Ellipse />
          <div className="home-container-item home-container-left">
            <div>
              <h3>与客户互动的新方式</h3>
              <p>客服、销售和服务工具，每一步都让你和客户的距离更近一点</p>
            </div>
            <div>
              <Button type="primary" onClick={() => handleChat('免费试用', ['a1', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>
          <div className="home-container-item home-container-right">
            <img src={imgComputerPerson} alt="" />
          </div>
        </div>
        <div className="online-chat-container">
          <Anchor id="online-service" />
          <h3>在线客服</h3>
          <p>打破坐席限制，基础产品仅需20元</p>
        </div>
      </div>
    );
  }
}

export default MainA;
